export default __webpack_public_path__ + "static/media/shutterstock_687008515.26100171.png";